import { ampli } from '../mixins/Amplitude/index.js'

export default () => {
  ampli.load({
    environment:
      location.hostname === 'lernpfad.ch' ? 'production' : 'development',
  })
}
